$.fn.textWidth = function(){
    const html_org = $(this).html();
    const html_calc = '<span>' + html_org + '</span>';
    $(this).html(html_calc);
    const width = $(this).find('span:first').width();
    $(this).html(html_org);
    return width;
};

$el = $('.dpl-page-nav');
if($el.length>0) {
    $(window).resize(position_pageNav());
    $(window).scroll(position_pageNav);
    window.addEventListener('load', (event) => {
        position_pageNav();
    });

    function position_pageNav() {
        const wWidth = $(window).width();
        const $header = $('.dpl-header');
        const $elsBefore = $el.parents('.wp-block-columns').prev();
        let offset = $header.outerHeight();

        if ($elsBefore.length > 0) {
            $elsBefore.each((i, e) => {
                offset += $(e).height() - $(window).scrollTop();
            });
        }

        if (wWidth < 767) {
            if (offset < $header.outerHeight()) {
                offset = $header.outerHeight();
            }
        } else {
            if (offset < 0 && $header.hasClass('headroom--pinned')) {
                offset = $header.outerHeight();
            }
        }

        if ($header.hasClass('headroom--unpinned') && offset < $header.outerHeight()) {
            if (offset < 0) {
                offset = 0;
            }
        }
        $el.css({
            'top': offset
        });
    }

    const as = $el.find('a');

    as.each((i, e) => {
        const eOb = $(e);
        eOb.css({
            'width' : (eOb.textWidth() +
                    parseInt(eOb.css('padding-left')
                        .replace('px', '')) +
                    parseInt(eOb.css('padding-right')
                        .replace('px', '')) + 5
            )
        });
    });

    as.on('click', function() {
        const a = $(this);
        const t = $(a.attr('href'));
        const $header = $('.dpl-header');
        const wWidth = $(window).width();

        if(t.length>0) {
            let scrollTop = ($(a.attr('href')).offset().top - a.parent().height());
            if(wWidth<767) {
                scrollTop = scrollTop - $header.outerHeight();
            }
            $('html, body').animate({
                scrollTop
            }, 250, function() {
                if(wWidth>767) {
                    $header.addClass('headroom--unpinned');
                    $header.removeClass('headroom--pinned');
                    position_pageNav();
                    setTimeout(function() {
                        $header.addClass('headroom--unpinned');
                        $header.removeClass('headroom--pinned');
                        position_pageNav();
                    },150);
                }
            });
        }
    })
}